import React from 'react';
import { Paper, Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { FormattedMessage } from 'react-intl';

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap'
  },
  div: {
    height: theme.spacing(31),
    width: '100%',
    backgroundColor: theme.palette.insights.noData,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  }
}));

const TeamTableNoData: React.FC = () => {
  const classes = useStyles();
  return (
    <Paper
      className={classes.container}
      data-testid={'my-Team-chart-no-data-container'}
    >
      <div className={classes.div}>
        <Typography variant="body2">
          <FormattedMessage id="insights.teamTable.noDataMessage" />
        </Typography>
      </div>
    </Paper>
  );
};
export default React.memo(TeamTableNoData);
